import { render, staticRenderFns } from "./TextLegend.vue?vue&type=template&id=67d815b7&"
import script from "./TextLegend.vue?vue&type=script&lang=js&"
export * from "./TextLegend.vue?vue&type=script&lang=js&"
import style0 from "./TextLegend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextLegend.vue"
export default component.exports